module.exports = __webpack_public_path__ + "img/product_group_3_img.db9300a4.png";